// @mui material components
import Fade from "@mui/material/Fade";

import colors from "../base/colors";
import typography from "../base/typography";
import borders from "../base/borders";
import boxShadows from "../base/boxShadows";

import pxToRem from "../functions/pxToRem";

const { background, text, divider } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

/** Fluent tooltip: raised surface with hairline border (no translucency, so text stays crisp). */
const tooltip = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(280),
      backgroundColor: background.paper,
      color: text.primary,
      border: `1px solid ${divider}`,
      boxShadow: boxShadows.md,
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textAlign: "left" as const,
      borderRadius: borderRadius.sm,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
    },

    arrow: {
      color: background.paper,
      "&::before": {
        border: `1px solid ${divider}`,
        boxSizing: "border-box" as const,
      },
    },
  },
};

export default tooltip;
